<nz-layout>
  <nz-header>
    <span class="section-header">{{'Tracheostomy'|translate}}</span>
  </nz-header>
  <nz-content>
    @for (cm of submenu; track cm) {
      @if (cm.path==componentPaths.ctParameters) {
        <app-ct-parameters [id]="cm.path" />
      }
      @if (cm.path==componentPaths.tubeCharacteristics) {
        <app-tube-characteristics [id]="cm.path" />
      }
    }
  </nz-content>
</nz-layout>